import Header from "./components/layout/Header";
import Hero from "./components/sections/Hero";
import Features from "./components/sections/Features";
import Footer from "./components/layout/Footer";
import About from "./components/sections/About";
import Contact from "./components/sections/Contact";
import NeuralBackground from "./components/NeuralBackground";
import HowItWorks from "./components/sections/HowItWorks";

function App() {
  return (
    <div className="min-h-screen flex flex-col relative">
      <NeuralBackground />
      <div className="relative z-10">
        <Header />
        <main className="flex-1">
          <Hero />
          <Features />
          <HowItWorks />
          <About />
          <Contact />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;
